import { render, staticRenderFns } from "./qiehuan.vue?vue&type=template&id=5242bfd0&scoped=true&"
import script from "./qiehuan.vue?vue&type=script&lang=js&"
export * from "./qiehuan.vue?vue&type=script&lang=js&"
import style0 from "./qiehuan.vue?vue&type=style&index=0&id=5242bfd0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5242bfd0",
  null
  
)

export default component.exports